
import { defineComponent } from "vue";
import RightToWorkCheck from "@/views/RightToWorkCheck.vue";

export default defineComponent({
  name: "RightToWorkCheckPopup",
  components: { RightToWorkCheck },
  props: {
    baseUrl: { type: String, required: true },
    officerId: { type: Number, required: true },
    officerName: { type: String, default: "" }
  },
  emits: ["close", "saved"]
});
